import { motion } from "framer-motion";
import { ReactNode } from "react";

interface SectionFadeInProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

const SectionFadeIn = ({ children, className = "", delay = 0 }: SectionFadeInProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default SectionFadeIn;
